import { h, render } from 'preact';
import { Provider } from 'preact-redux';
import { attributesToObject } from '../util';
import { store } from '../redux';

const mount = (node, Component) => {
    if (node._componentConstructor) {
        return;
    }
    render(
        <Provider store={store}>
            <Component innerHTML={node.innerHTML} {...attributesToObject(node.attributes)} />
        </Provider>,
        node.parentNode,
        node
    );
    node._component = Component;
};

const forEachNode = (selector, iterator) => {
    const nodes = document.querySelectorAll(selector);
    Array.prototype.forEach.call(nodes, iterator);
};

const mountEachNode = (tag, Component) =>
    forEachNode(tag, (node) =>
        mount(node, Component)
    );

export const register = (tag, Component) => {
    // mount to existing elements
    mountEachNode(tag, Component);

    // watch for new elements
    const observer = new MutationObserver(() => {
        mountEachNode(tag, Component);
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};



// WEBPACK FOOTER //
// ./app/preact/mount.js